const StagConfig = {
  apiBaseUrl: 'https://staging-api.disputealert.com',
  apiBpBaseUrl: 'https://bp-staging.disputealert.com',
};

export default StagConfig;
